import loadingSpinner from "./loadingSpinner.component";

const loadingSpinnerModule = angular
  .module("app.components.loadingSpinner", [])
  .component("loadingSpinner", loadingSpinner);

export default loadingSpinnerModule;



// WEBPACK FOOTER //
// ./src/components/loadingSpinner/loadingSpinner.module.js